import React from 'react';
import katex from 'katex';
import 'katex/dist/katex.min.css';
import 'katex/contrib/mhchem/mhchem.js';
import type { ChemistryBlock } from '@/types/contentBlocks';

interface ChemistryBlockProps {
  block: ChemistryBlock;
  isDarkMode: boolean;
}

export const ChemistryBlockRenderer: React.FC<ChemistryBlockProps> = ({ block, isDarkMode }) => {
  const [html, setHtml] = React.useState<string>('');
  const [error, setError] = React.useState<string | null>(null);

  React.useEffect(() => {
    try {
      const rendered = katex.renderToString(block.formula, {
        displayMode: block.displayMode,
        throwOnError: false,
        errorColor: isDarkMode ? '#ff9999' : '#cc0000',
        strict: false,
        trust: true, // Required for mhchem
        output: 'html',
      });
      setHtml(rendered);
      setError(null);
    } catch (err) {
      console.warn('Chemistry rendering error:', err);
      setError(block.formula);
    }
  }, [block.formula, block.displayMode, isDarkMode]);

  if (error) {
    return (
      <div className={`my-2 p-2 rounded ${isDarkMode ? 'bg-yellow-900/20 text-yellow-300' : 'bg-yellow-50 text-yellow-700'}`}>
        <code>{error}</code>
      </div>
    );
  }

  return (
    <div
      className={`katex-block chemical-equation ${block.displayMode ? 'my-4' : 'inline'}`}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};
